import type React from 'react';
import { Field, useFormikContext } from 'formik';
import { useQuery } from '@zg-rentals/react-query5';

import type { RentalManagerUserMaintenancePropertyDto } from '@zg-rentals/rental-manager-env';
import { RentalManagerUserMaintenancePropertiesWebApiHandler_list } from '@zg-rentals/rental-manager-env';

import { FormField, FormHelp, Label, Select } from '@zillow/constellation-10';

export type CreateFormFields = {
  category: string;
  cost?: number;
  description: string;
  feedModelId: string;
  isMultifamily: boolean;
  listingAlias: string;
  property?: string;
  title: string;
  unit?: string;
  vendor?: string;
};

const Property = () => {
  const { values, setFieldValue, errors, setFieldTouched, touched } = useFormikContext<CreateFormFields>();

  // NOTE: returns the listings which qualify for maintenance.  the server should remain rental-manager-api
  const { data: propertiesList } = useQuery({
    queryKey: ['getTaskDetails'],
    queryFn: () => RentalManagerUserMaintenancePropertiesWebApiHandler_list(),
  });

  return (
    <FormField
      css={{ marginTop: 'default' }}
      required
      error={!!errors.listingAlias && touched.listingAlias}
      label={<Label>Property</Label>}
      control={
        <Field
          as={Select}
          value={values.property}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            const selectedPropertyData = propertiesList?.listings.find(
              (property: RentalManagerUserMaintenancePropertyDto) => property.fullAddress === e.target.value,
            );

            if (selectedPropertyData) {
              setFieldValue('property', selectedPropertyData.fullAddress);
              setFieldValue('listingAlias', selectedPropertyData.listingAlias);
              setFieldValue('feedModelId', selectedPropertyData.feedModelId);
            }

            setTimeout(() => setFieldTouched('property', true));
          }}
          name="listingAlias"
        >
          <option></option>
          {propertiesList?.listings?.map((property, idx) => (
            <option key={`${property.listingAlias}=${idx}`} value={property.fullAddress}>
              {property.fullAddress}
            </option>
          ))}
        </Field>
      }
      description={errors.listingAlias && touched.listingAlias ? <FormHelp>{errors.listingAlias}</FormHelp> : undefined}
    />
  );
};

export default Property;
